import { render } from "./jober.vue?vue&type=template&id=44cf633d&scoped=true"
import script from "./jober.vue?vue&type=script&lang=js"
export * from "./jober.vue?vue&type=script&lang=js"

import "./jober.vue?vue&type=style&index=0&id=44cf633d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44cf633d"]])

export default __exports__